import { Trans, useTranslation } from "react-i18next";
import { BaseRadio } from "src/components/layout/BaseRadio";
import { DocumentProofRequest } from "../types";

type Props = {
  documentProofRequest: DocumentProofRequest;
};

// 지출 증빙 선택 컴포넌트 (읽기 전용)
const MeansOfProof = ({ documentProofRequest }: Props) => {
  const { t } = useTranslation("contract");
  const isRequest = (documentProofRequest as any)?.isRequired ?? (documentProofRequest as any)?.isRequest ?? false;

  return (
    <section className="base-section-layout top-divider">
      <div className="base-section-layout__container">
        <div className="base-section-layout__wrap mb30 pb10">
          <div className="base-section-layout__title-wrap">
            <h2 className="">{t("detail.expenseDocumentation")}</h2>
          </div>
          <BaseRadio
            id="noProof"
            name="proofOption"
            value={"noProof"}
            label={t("detail.noDocumentation")}
            className="mb10"
            disabled={true}
            checked={!isRequest}
            onChange={() => {}}
          />
          {!isRequest && (
            <p className="font14 text-primary3 pl28 mb20 lh-20">
              <Trans t={t} i18nKey="detail.selfIssueNotice" components={{ br: <br /> }} />
            </p>
          )}
          <BaseRadio id="proof" name="proofOption" value={"proof"} label={t("detail.requestDocumentation")} disabled={true} checked={isRequest} onChange={() => {}} />
        </div>
      </div>
    </section>
  );
};

export default MeansOfProof;
